import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, BehaviorSubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  ToasterService,
  ToasterPosition,
} from 'src/app/shared/services/toaster/toaster.service';
import { VoiceService } from '../voice.service';
import { IVoice } from 'src/app/talent-litmus-core/game-core/level1-core/voice-core';
import { VoiceFormComponent } from '../voice-form/voice-form.component';
import { DEFAULT_Y_CORD } from 'src/app/shared/configs/global-values.constants';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-clone-voice',
  templateUrl: './clone-voice.component.html',
})
export class CloneVoiceComponent implements OnInit, OnDestroy {
  private _unsubscribe$ = new Subject<void>();
  @ViewChild(VoiceFormComponent) voiceFormComponent: VoiceFormComponent;

  @Input()
  public voice: IVoice;
  visibleVoice: IVoice;
  voiceName: string;
  cloning$ = new BehaviorSubject<boolean>(false);
  isInvalid: boolean;

  constructor(
    public modal: NgbActiveModal,
    private _voiceService: VoiceService,
    private _toasterService: ToasterService,
    private _scroller: ViewportScroller,
  ) {}

  ngOnInit(): void {
    this.visibleVoice = JSON.parse(JSON.stringify(this.voice));
    this.voiceName = this.voice.name;
    this.visibleVoice.name = '';
    this.isInvalid = true;
  }

  submit(): void {
    const dataInput = this.voiceFormComponent.onSubmit();
    const query = {
      name: dataInput.name,
      url: dataInput.url,
    };
    this.cloning$.next(true);
    this._voiceService
      .addVoice(query)
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe(
        (data: IVoice) => {
          this.cloning$.next(false);
          this._toasterService.showSuccess(
            'Voice cloned successfully',
            ToasterPosition.topRightSticky,
          );
          this.modal.close(true);
          this._voiceService.moveToLastPage();
          this._voiceService.setSelectedId(data?._id);
          this._scroller.scrollToPosition([0, DEFAULT_Y_CORD]);
        },
        (err) => {
          console.log(err);
          this.cloning$.next(false);
          this._toasterService.showError(
            err?.error?.message,
            ToasterPosition.topRightSticky,
          );
        },
      );
  }

  onValidityChange(validity?: boolean): void {
    this.isInvalid = validity;
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }
}
